<mat-card
  appearance="outlined"
  [ngClass]="'side-menu' + (' side-menu--' + (isOpen ? 'open' : 'closed')) + (' side-menu--' + (isOpenInMobile ? 'mobile-open' : 'mobile-closed'))">
  <div class="site-selector-container">
    @if (user && user.hasSites) {
      <div class="site-selector-container__row">
        <app-site-selector class="site-selector"></app-site-selector>
      </div>
    }
    <hr class="site-selector-container__separator" />
  </div>

  <div fxLayout="column" class="side-menu__content">
    @if (user && user.hasSites) {
      <nav class="side-menu__nav">
        @if (activeTopLevel(); as topLevel) {
          <a
            class="side-menu__headline side-menu__headline--active"
            [routerLink]="topLevel.url"
            (click)="onSubItemClick()"
            [attr.data-test]="topLevel.dataTest + '-headline'">
            <mat-icon class="side-menu__headline-icon">{{ topLevel.icon }}</mat-icon>
            <span>{{ topLevel.translationKey | translate }}</span>
            @if (shouldShowUpgradeTagForTopLevel(topLevel)) {
              <app-account-upgrade-tag></app-account-upgrade-tag>
            }
          </a>
        }
        @for (entry of activeSubItems(); track $index) {
          @if (isSeparator(entry)) {
            <hr class="side-menu__separator" />
          } @else if (isGroup(entry)) {
            <button
              type="button"
              class="side-menu__group-toggle"
              [class.side-menu__group-toggle--expanded]="isGroupExpanded(entry)"
              (click)="toggleGroup(entry)"
              [attr.aria-expanded]="isGroupExpanded(entry)"
              [attr.data-test]="entry.dataTest">
              <span class="side-menu__item-label">{{ entry.translationKey | translate }}</span>
              @if (entry.adminOnly) {
                <mat-icon class="side-menu__admin-tag">font_download</mat-icon>
              }
              <mat-icon class="side-menu__group-chevron">chevron_right</mat-icon>
            </button>
            @if (isGroupExpanded(entry)) {
              <div class="side-menu__group-items">
                @for (item of entry.items; track item.translationKey) {
                  @if (item.disabled) {
                    <button
                      type="button"
                      class="side-menu__item side-menu__item--nested side-menu__item--disabled"
                      disabled
                      [matTooltip]="'side-menu.coming-soon' | translate"
                      matTooltipPosition="right"
                      [attr.data-test]="item.dataTest">
                      <span class="side-menu__item-label">{{ item.translationKey | translate }}</span>
                      @if (item.adminOnly) {
                        <mat-icon class="side-menu__admin-tag">font_download</mat-icon>
                      }
                    </button>
                  } @else {
                    <a
                      class="side-menu__item side-menu__item--nested"
                      [routerLink]="item.url"
                      [queryParams]="item.queryParams ?? null"
                      routerLinkActive="side-menu__item--active"
                      [routerLinkActiveOptions]="routerLinkActiveOptions"
                      (click)="onSubItemClick()"
                      [attr.data-test]="item.dataTest">
                      <span class="side-menu__item-label">{{ item.translationKey | translate }}</span>
                      @if (item.betaTag) {
                        <span class="side-menu__beta-tag">BETA</span>
                      }
                      @if (shouldShowUpgradeTag(item)) {
                        <app-account-upgrade-tag></app-account-upgrade-tag>
                      }
                      @if (item.adminOnly) {
                        <mat-icon class="side-menu__admin-tag">font_download</mat-icon>
                      }
                    </a>
                  }
                  @if (itemChildrenVisible(item)) {
                    @for (child of visibleChildren(item); track child.translationKey) {
                      <a
                        class="side-menu__item side-menu__item--nested side-menu__item--child"
                        [routerLink]="child.url"
                        [queryParams]="child.queryParams ?? null"
                        routerLinkActive="side-menu__item--active"
                        [routerLinkActiveOptions]="routerLinkActiveOptions"
                        (click)="onSubItemClick()"
                        [attr.data-test]="child.dataTest">
                        <span class="side-menu__item-label">{{ child.translationKey | translate }}</span>
                      </a>
                    }
                  }
                }
              </div>
            }
          } @else if (entry.externalUrl) {
            <a
              class="side-menu__item"
              [href]="entry.externalUrl"
              target="_blank"
              rel="noopener noreferrer"
              (click)="onSubItemClick()"
              [attr.data-test]="entry.dataTest">
              <span class="side-menu__item-label">{{ entry.translationKey | translate }}</span>
              @if (entry.adminOnly) {
                <mat-icon class="side-menu__admin-tag">font_download</mat-icon>
              }
              <mat-icon class="side-menu__item-external-icon">open_in_new</mat-icon>
            </a>
          } @else if (entry.disabled) {
            <button
              type="button"
              class="side-menu__item side-menu__item--disabled"
              disabled
              [matTooltip]="'side-menu.coming-soon' | translate"
              matTooltipPosition="right"
              [attr.data-test]="entry.dataTest">
              <span class="side-menu__item-label">{{ entry.translationKey | translate }}</span>
              @if (entry.adminOnly) {
                <mat-icon class="side-menu__admin-tag">font_download</mat-icon>
              }
            </button>
          } @else {
            <a
              class="side-menu__item"
              [routerLink]="entry.url"
              [queryParams]="entry.queryParams ?? null"
              routerLinkActive="side-menu__item--active"
              [routerLinkActiveOptions]="routerLinkActiveOptions"
              (click)="onSubItemClick()"
              [attr.data-test]="entry.dataTest">
              @if (entry.icon) {
                <mat-icon class="side-menu__item-icon">{{ entry.icon }}</mat-icon>
              }
              <span class="side-menu__item-label">{{ entry.translationKey | translate }}</span>
              @if (entry.betaTag) {
                <span class="side-menu__beta-tag">BETA</span>
              }
              @if (entry.newTag) {
                <span class="side-menu__new-tag">NEW</span>
              }
              @if (shouldShowUpgradeTag(entry)) {
                <app-account-upgrade-tag></app-account-upgrade-tag>
              }
              @if (entry.adminOnly) {
                <mat-icon class="side-menu__admin-tag">font_download</mat-icon>
              }
            </a>
            @if (itemChildrenVisible(entry)) {
              @for (child of visibleChildren(entry); track child.translationKey) {
                <a
                  class="side-menu__item side-menu__item--child"
                  [routerLink]="child.url"
                  [queryParams]="child.queryParams ?? null"
                  routerLinkActive="side-menu__item--active"
                  [routerLinkActiveOptions]="routerLinkActiveOptions"
                  (click)="onSubItemClick()"
                  [attr.data-test]="child.dataTest">
                  <span class="side-menu__item-label">{{ child.translationKey | translate }}</span>
                </a>
              }
            }
          }
        }
      </nav>
    }
  </div>
</mat-card>
